import type { Category } from '@prezly/sdk';
import { getLocalizedCategoryData } from '@prezly/theme-kit-core';
import { useCurrentLocale } from '@prezly/theme-kit-nextjs';
import { useIntl } from 'react-intl';

import { PageTitle } from '@/components';
import { CUSTOM_MESSAGES } from '@/intl/messageDescriptors';

import styles from './CategoryHeader.module.scss';

type Props = {
    category: Category;
};

function CategoryHeader({ category }: Props) {
    const currentLocale = useCurrentLocale();
    const { name, description } = getLocalizedCategoryData(category, currentLocale);
    const { formatMessage } = useIntl();

    return (
        <PageTitle
            className={styles.header}
            title={name}
            subtitle={description}
            paths={[
                { href: '/', title: formatMessage(CUSTOM_MESSAGES.site.home) },
                { title: name },
            ]}
        />
    );
}

export default CategoryHeader;
